import React from "react";

const GiftSVG = ({ className }) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="42.225"
      height="36.947"
      viewBox="0 0 42.225 36.947"
    >
      <path
        fill="#fff"
        d="M2.639 66.308a2.636 2.636 0 002.639 2.639h13.2v-13.2H2.639zm21.113 2.639h13.2a2.636 2.636 0 002.639-2.639V55.752H23.752zm15.834-26.391h-3.472a7.191 7.191 0 00.833-3.3A7.268 7.268 0 0029.69 32c-3.431 0-5.649 1.757-8.495 5.633C18.35 33.757 16.131 32 12.7 32a7.268 7.268 0 00-7.257 7.257 7.09 7.09 0 00.833 3.3H2.639A2.636 2.636 0 000 45.2v6.6a1.323 1.323 0 001.32 1.32h39.586a1.323 1.323 0 001.32-1.32v-6.6a2.636 2.636 0 00-2.64-2.644zm-26.894 0a3.3 3.3 0 010-6.6c1.641 0 2.853.272 7.1 6.6zm17 0h-7.1c4.239-6.309 5.418-6.6 7.1-6.6a3.3 3.3 0 110 6.6z"
        transform="translate(0 -32)"
      ></path>
    </svg>
  );
};

export default GiftSVG;
